import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const HotelInfoContext = createContext(null);

export const HotelInfoProvider = ({ children }) => {
  const [hotelInfo, setHotelInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const tenantId =
    typeof window !== "undefined" && window.location.hostname
      ? window.location.hostname.split(".")[0] !== "localhost"
        ? window.location.hostname.split(".")[0]
        : "defaultTenant"
      : null;

  const fetchHotelInfo = async () => {
    if (!tenantId) return;
    setLoading(true);
    try {
      // Prefer tenant-aware endpoint
      const res = await axios.get("/api/hotelInfo/getallinfo", {
        headers: { "X-Tenant-ID": tenantId },
      });
      setHotelInfo(res.data || null);
    } catch (err) {
      console.error("Error fetching hotel info:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotelInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  return (
    <HotelInfoContext.Provider
      value={{ hotelInfo, loading, refresh: fetchHotelInfo }}
    >
      {children}
    </HotelInfoContext.Provider>
  );
};

export const useHotelInfoContext = () => useContext(HotelInfoContext);

export default HotelInfoContext;
